// Local - Styled Components
import { SCNavTopAlertBar } from './styles'

const NavTopAlertBar = () => {
  return (
    <>
      <SCNavTopAlertBar to='/blog/april-2026-rfq'>
        <strong>New Release!</strong>&nbsp;Improved Request for Quote Management
      </SCNavTopAlertBar>
    </>
  )
}

export default NavTopAlertBar
